/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PhysicalCountParsePreviewMetaDto = {
  locationId: number;
  locationName: string;
  fileName: string;
  fileSizeBytes: number;
  parseModeApplied: PhysicalCountParsePreviewMetaDto.parseModeApplied;
  normalizationApplied: PhysicalCountParsePreviewMetaDto.normalizationApplied;
  parsedAtIso: string;
};
export namespace PhysicalCountParsePreviewMetaDto {
  export enum parseModeApplied {
    SINGLE_ROW = 'single_row',
    SINGLE_COLUMN = 'single_column',
  }
  export enum normalizationApplied {
    PRESERVE_CASE = 'preserve_case',
    UPPERCASE = 'uppercase',
  }
}
